module.exports = __webpack_public_path__ + "img/p1-p1-btn.88dbce77.png";